module.exports = __webpack_public_path__ + "fd1f1f1f36eae9fb9340da587f9eba92.MP3";